class GiftNoteHandler extends HTMLElement {
  constructor() {
    super();
    this.textAreaLimit = this.dataset.giftNoteLimit;
    this.giftVariant = parseInt(this.dataset.giftVariant);
    this.product = parseInt(this.dataset.product);
    this.giftNoteAttribute = this.dataset.giftNoteAttribute;
    this.commitOn = this.dataset.commitOn; // "live" or "save" - the former commits changes live as the user edits the form, the latter commits with a button
    this.enableValidation = this.dataset.enableValidation;
    this.enablePreSubmitValidation = this.dataset.preSubmitValidation;

    // DOM elements
    this.field = this.querySelector(`[name="attributes[${this.giftNoteAttribute}]"]`);
    this.limitCounter = this.querySelector("[data-gift-limit-counter]");
    this.details = this.querySelector("[data-gift-note-details]");
    this.allDetails = [...document.querySelectorAll("details[data-collapsible]")];
    this.giftCheckbox = this.querySelector("[data-enable-gift]");

    this.field.addEventListener("input", this.updateTextAreaLimitText.bind(this));

    this.isGiftCheckboxChecked = false;

    document.addEventListener("theme:gwp:cartupdate", (e) => {
      // Remove the gift note if it's the only thing in cart
      if (this.getGiftInCart() && [...document.querySelectorAll(".cart__item")].length === 1) {
        this.removeGiftFromCart();
      }
    });

    if (this.enableValidation) {
      this.validationCatcher = document.createElement("div");
      const container = document.querySelector('button[name="checkout"]').parentElement;

      this.validationCatcher.style.position = "absolute";
      this.validationCatcher.style.top = "0";
      this.validationCatcher.style.left = "0";
      this.validationCatcher.style.width = "100%";
      this.validationCatcher.style.height = "100%";
      this.validationCatcher.style.zIndex = "999";
      if (!this.getGiftInCart()) this.validationCatcher.style.pointerEvents = "none";
      container.appendChild(this.validationCatcher);

      // this.validationCatcher.addEventListener("click", this.validateGiftNote.bind(this));
      container.addEventListener("click", this.validateGiftNote.bind(this));
    }
    if (this.enablePreSubmitValidation) {
      const atcButton = this.closest(".product__content").querySelector("[data-add-to-cart]");
      atcButton.addEventListener("click", this.validateGiftNote.bind(this));
    }

    if (this.commitOn === "live") {
      this.initCommitOnLive();
    } else {
      this.initCommitOnSave();
    }

    document.body.addEventListener("gift-note-added", (e) => {
      if (this.commitOn === "save") this.style.display = "none";
      const note = e.detail;
      if (note) this.field.value = note;
      if (this.validationCatcher) this.validationCatcher.style.pointerEvents = note && note.length ? "none" : "all";
      this.giftCheckbox.classList.add("checked");
      this.isGiftCheckboxChecked = true;
      this.allDetails.forEach((d) => (d.open = false));
      this.details.setAttribute("open", "true");
      this.details.querySelector(".cart__widget__content").style.height = "auto";
    });

    document.body.addEventListener("gift-note-removed", (e) => {
      if (this.commitOn === "save") this.style.display = "block";
      if (this.validationCatcher) this.validationCatcher.style.pointerEvents = "none";
    });

    this.updateTextAreaLimitText({ target: this.field });

    if (this.getGiftInCart()) {
      this.allDetails.forEach((d) => (d.open = false));
      this.details.setAttribute("open", "true");
      this.details.querySelector(".cart__widget__content").style.height = "auto";
      this.isGiftCheckboxChecked = true;
      this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
    }
  }

  initCommitOnLive() {
    this.processChange = this.debounce((e) => this.updateGiftNoteAttribute(e.target.value));
    this.field.addEventListener("input", this.processChange.bind(this));

    this.details.addEventListener("toggle", (e) => {
      const isOpen = e.target.open;
      if (!this.isGiftCheckboxChecked && isOpen) {
        this.isGiftCheckboxChecked = true;
        this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
        this.addGiftToCart();
      }
    });

    this.giftCheckbox.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!this.isGiftCheckboxChecked) {
        this.addGiftToCart();
        this.isGiftCheckboxChecked = true;
        this.allDetails.forEach((d) => (d.open = false));
        this.details.setAttribute("open", "true");
        this.details.querySelector(".cart__widget__content").style.height = "auto";
      } else {
        this.details.open = false;
        this.isGiftCheckboxChecked = false;
        this.removeGiftFromCart();
      }
      this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
    });
  }

  initCommitOnSave() {
    if (this.getGiftInCart()) this.style.display = "none";
    document.addEventListener("theme:giftnote:cartupdate", (e) => {
      if (!this.commitOn === "save") return;
      if (!this.field.value?.length) return;
      if (this.getGiftInCart()) return;
      if (!this.isGiftCheckboxChecked) return;
      this.addGiftToCart(this.field.value);
    });

    this.details.addEventListener("toggle", (e) => {
      const isOpen = e.target.open;
      if (!this.isGiftCheckboxChecked && isOpen) {
        this.isGiftCheckboxChecked = true;
        this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
      }
      if (isOpen) {
        this.details.setAttribute("open", "true");
        this.details.querySelector(".cart__widget__content").style.height = "auto";
      } else {
        if (!this.getGiftInCart()) {
          this.isGiftCheckboxChecked = false;
          this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
        }
      }
    });

    this.giftCheckbox.addEventListener("click", (e) => {
      this.details.setAttribute("open", "true");
      this.details.querySelector(".cart__widget__content").style.height = "auto";
    });
  }

  validateGiftNote(e) {
    if (this.enableValidation && !this.getGiftInCart()) return true;
    if (this.enablePreSubmitValidation && this.getGiftInCart()) return true;
    if (this.field.value.length) return true;
    if (!this.isGiftCheckboxChecked) return true;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (this.enableValidation) this.allDetails.forEach((d) => (d.open = false));
    this.details.setAttribute("open", "true");
    this.details.querySelector(".cart__widget__content").style.height = "auto";
    this.showErrorMessage();
  }

  showErrorMessage() {
    this.field.classList.add("invalid");
  }

  hideErrorMessage() {
    this.field.classList.remove("invalid");
  }

  getGiftInCart() {
    const lineItems = [...document.querySelectorAll(".cart__item")];
    const lineItem = lineItems.find((item) => {
      return parseInt(item.dataset.variant) === this.giftVariant;
    });
    return lineItem;
  }

  debounce(func, timeout = 500) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  updateTextAreaLimitText(e) {
    if (this.validationCatcher && this.getGiftInCart()) {
      this.validationCatcher.style.pointerEvents = e.target.value.length > 0 ? "none" : "all";
    }
    this.hideErrorMessage();
    if (!this.textAreaLimit || !this.textAreaLimit.length) return;

    const currentText = e.target.value;
    const remainingChars = this.textAreaLimit - currentText.length;
    const truncatedText = currentText.slice(0, this.textAreaLimit);
    e.target.value = truncatedText; // Cut off any text beyond the limit
    if (this.limitCounter) this.limitCounter.innerText = remainingChars;
    this.limitCounter.classList.toggle("error", truncatedText.length === this.textAreaLimit);
  }

  async addGiftToCart(note) {
    if (!window.cart) return;
    if (this.getGiftInCart()) return;
    const formData = new FormData();
    const data = {
      id: this.giftVariant,
      form_type: "product",
      utf8: "✓",
      quantity: 1,
      "product-id": this.product,
    };
    if (note) {
      data[`properties[Gift Note]`] = note;
    }
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    await window.cart.addToCart(formData, null);
    const giftNoteAddedEvent = new CustomEvent("gift-note-added", { detail: note || false });
    document.body.dispatchEvent(giftNoteAddedEvent);
    if (note) {
      await this.updateGiftNoteAttribute(note, true);
    }
  }

  async removeGiftFromCart() {
    if (!window.cart) return;
    const lineItem = this.getGiftInCart();
    if (!lineItem) return;
    const lineItemId = lineItem.dataset.item;
    let updates = { [lineItemId]: 0 };
    window.cart.updatesCart(
      updates,
      lineItem,
      {
        [this.giftNoteAttribute]: "",
      },
      true
    );
    const giftNoteRemovedEvent = new CustomEvent("gift-note-removed");
    document.body.dispatchEvent(giftNoteRemovedEvent);
  }

  async updateGiftNoteAttribute(value, bypassCartItem) {
    if (!window.cart) return;
    const lineItem = this.getGiftInCart();
    if (!lineItem && !bypassCartItem) return;

    const res = await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          [this.giftNoteAttribute]: value,
        },
      }),
    });
    const data = await res.json();
    if (!bypassCartItem) {
      const lineItemId = lineItem.dataset.item;
      const index = lineItem.dataset.itemIndex;
      const changeRes = await fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          line: index,
          properties: {
            "Gift Note": value,
          },
        }),
      });
      const changeData = await changeRes.json();
    }
  }
}

if (!customElements.get("gift-note-handler")) customElements.define("gift-note-handler", GiftNoteHandler);
